import CloseCircleSVG from "@design-system/ui-icons/vanilla/CloseCircle"
import { createIcon } from "../createIcon"

export const CloseCircleIcon = createIcon(CloseCircleSVG)
